import { render } from "./Dialogue.vue?vue&type=template&id=007b64df&bindings={\"quoteTitle\":\"props\",\"quoteText\":\"props\",\"characterDescription\":\"props\",\"imageURL\":\"props\",\"alignLeft\":\"props\",\"number\":\"props\",\"quoteTextHTML\":\"data\",\"characterDescriptionHTML\":\"data\"}"
import script from "./Dialogue.vue?vue&type=script&lang=js"
export * from "./Dialogue.vue?vue&type=script&lang=js"

import "./Dialogue.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script